import BaseNode from '../BaseNode'
import SpliceNode from '../SpliceNode'
import GroundNode from '../GroundNode'

export default function nodeRouter({ node, onNodeClick, onPortClick, theme }) {
  const { category } = node.properties.data
  switch (category) {
    case 'ground':
      return (
        <GroundNode
          node={node}
          onNodeClick={onNodeClick}
          onPortClick={onPortClick}
          theme={theme}
        />
      )
    case 'splice':
      return (
        <SpliceNode
          node={node}
          onNodeClick={onNodeClick}
          onPortClick={onPortClick}
          theme={theme}
        />
      )
    default:
      return (
        <BaseNode
          node={node}
          onNodeClick={onNodeClick}
          onPortClick={onPortClick}
        />
      )
  }
}
